export enum OEM {
	ACURA = 'acura',
	GENESIS = 'genesis',
	HONDA = 'honda',
	NISSAN = 'nissan',
	WAGONEER = 'wagoneer',
}

export const OEMS_FORBIDDING_EMOJIS: OEM[] = [OEM.GENESIS];
